import { FaPlay } from 'react-icons/fa';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { useDateUpdate } from 'src/utils/helper';

const CardV = ({ data, path, setBackground = false, eventDataLayer }) => {
  // console.log('VDO-cardV', data);

  const dateUpdate = useDateUpdate(data?.published_at);
  const category = data?.section ? data?.section?.th : 'ข่าว';
  return (
    <>
      <a
        href={path}
        //! DATALAYER
        onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}
      >
        <div className='card-wrapper'>
          <div className='card-video-v'>
            <div className='position-absolute button-card-video-v'>
              <FaPlay className='card-video-v-icon' />
            </div>
            <div className='card-v-thumb'>
              <div className='resolution-image'>
                <img src={`${data.image}`} alt={data.title} />
              </div>
            </div>
            <div className={`video-info ${setBackground && '--set-bg'}`}>
              <h2>{data.title}</h2>
              {data.description && <p className='blurb'>{data.description}</p>}
              <span className='video-duration'>
                {/* {category} {data.duration === null ? '' : data.duration?.slice(2, -1).replace('M', ':')} */}
              </span>
              {data.published_at && <span className='video-date'> | {dateUpdate}</span>}
            </div>
          </div>
        </div>
      </a>
    </>
  );
};

export default CardV;
